import {DateTime} from 'luxon';

const priceFilter = (
    price: number,
    config?: {sign?: string; unit?: string},
) => {
    if (typeof price !== 'number') {
        return 0;
    }
    if (!config) {
        return `${price.toLocaleString()}`;
    }

    return `${config.sign ?? ''}${price.toLocaleString()}${config.unit ?? ''}`;
};

const businessLicenseNumberFilter = (value: string) => {
    return value.slice(0, 3) + '-' + value.slice(3, 5) + '-' + value.slice(5);
};

const dateFilter = (rawDate: string) => {
    const formatted = DateTime.fromISO(rawDate)
        .setLocale('ko')
        .toFormat('yyyy.MM.dd (ccc) HH:mm:ss');

    return formatted;
};

export {priceFilter, businessLicenseNumberFilter, dateFilter};
